import { render, staticRenderFns } from "./PoliticalParty.vue?vue&type=template&id=569ab142&scoped=true&"
import script from "./PoliticalParty.vue?vue&type=script&lang=js&"
export * from "./PoliticalParty.vue?vue&type=script&lang=js&"
import style0 from "./PoliticalParty.vue?vue&type=style&index=0&id=569ab142&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569ab142",
  null
  
)

export default component.exports